var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameDetailsInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 95,
    viewBox: "0 0 68 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_2035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7107 90.4482C67.7107 92.9272 65.7042 94.9419 63.2252 94.9419L5.22026 95.0083C3.24697 95.0083 1.57215 93.7397 0.9669 91.9737C0.809368 91.5177 0.726457 91.0368 0.726457 90.5311L0.635254 6.88165C0.635254 4.4026 2.64171 2.38785 5.12077 2.38785L58.3831 2.32981L63.1257 2.32152C65.6047 2.32152 67.6195 4.32798 67.6195 6.80703L67.7107 90.4482Z",
    fill: "url(#paint0_linear_306_2035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6996 89.9673L6.73758 90.0253C5.4027 90.0253 4.32485 88.9474 4.32485 87.6126L4.24194 9.76697C4.24194 8.43209 5.31979 7.35424 6.65467 7.35424L61.6084 7.2962C62.9433 7.2962 64.0211 8.37405 64.0211 9.70893L64.1041 87.5545C64.1123 88.8811 63.0345 89.9673 61.6996 89.9673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9804 13.7136L13.8927 13.7633C12.5661 13.7633 11.48 12.6855 11.48 11.3589L11.4717 4.67621C11.4717 3.34963 12.5495 2.26349 13.8761 2.26349L53.9721 2.22203C55.2987 2.22203 56.3848 3.29988 56.3848 4.62646L56.3931 11.3091C56.3848 12.6357 55.307 13.7136 53.9804 13.7136ZM13.8761 3.49058C13.2294 3.49058 12.6988 4.02121 12.6988 4.66792L12.7071 11.3506C12.7071 11.9973 13.2377 12.5279 13.8844 12.5279L53.9804 12.4865C54.6271 12.4865 55.1578 11.9558 55.1578 11.3091L55.1495 4.62646C55.1495 3.97975 54.6188 3.44912 53.9721 3.44912L13.8761 3.49058Z",
    fill: "url(#paint1_linear_306_2035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8446 5.11564L15.41 5.1571C14.9955 5.1571 14.6638 4.82545 14.6638 4.41089V0.787659C14.6638 0.373102 14.9955 0.0414557 15.41 0.0414557L52.8363 0C53.2509 0 53.5825 0.331646 53.5825 0.746203V4.36944C53.5908 4.78399 53.2591 5.11564 52.8446 5.11564Z",
    fill: "url(#paint2_linear_306_2035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4432 5.15709L52.8114 5.11564C53.2425 5.11564 53.5908 4.76741 53.5908 4.33627V2.56197L14.6555 2.60342V4.37773C14.6555 4.80887 15.012 5.15709 15.4432 5.15709Z",
    fill: "#58D6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5763 81.2118L25.3428 61.6447L22.7228 70.1597L15.2276 70.168C14.7715 70.168 14.4067 69.8032 14.4067 69.3472C14.4067 68.8912 14.7715 68.5264 15.2276 68.5264L21.5205 68.5181L25.8402 54.4977L29.0738 74.1146L33.2691 60.6415L35.4994 67.0257L40.5239 54.846L45.4074 74.1643L47.248 68.0206L52.6372 68.0123C53.0932 68.0123 53.4581 68.3771 53.4581 68.8331C53.4581 69.2891 53.0932 69.6539 52.6372 69.6539L48.4668 69.6622L45.2747 80.3164L40.1508 60.0528L35.3668 71.6355L33.352 65.8732L28.5763 81.2118Z",
    fill: "#58D6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0213 43.4871L12.4832 43.4954C10.7835 43.4954 9.39061 42.1107 9.39061 40.4111L9.37402 25.6777C9.37402 23.978 10.7586 22.5851 12.4583 22.5851L22.9964 22.5768C24.6961 22.5768 26.089 23.9614 26.089 25.6611L26.1056 40.3945C26.1056 42.0942 24.7209 43.4788 23.0213 43.4871ZM12.45 23.4805C11.2395 23.4805 10.2612 24.4672 10.2612 25.6777L10.2778 40.4111C10.2778 41.6216 11.2644 42.5999 12.4749 42.5999L23.013 42.5916C24.2235 42.5916 25.2018 41.605 25.2018 40.3945L25.1853 25.6611C25.1853 24.4506 24.1986 23.4722 22.9881 23.4722L12.45 23.4805Z",
    fill: "url(#paint3_linear_306_2035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7398 40.6598C22.7228 40.6515 24.2732 37.7745 24.2732 37.7745C24.0493 37.4926 23.7674 37.2438 23.386 36.9951C22.076 36.1411 21.0231 35.7763 20.5836 35.4115C20.1359 35.055 19.8872 34.5326 19.8872 34.5326L19.6136 34.6985C19.6136 34.6985 19.4477 34.1264 19.539 33.2558C19.539 33.2558 19.9286 33.1563 20.2188 31.838C20.6831 31.9292 21.2303 30.7519 20.9733 30.3207C20.8075 30.0388 20.6085 30.0637 20.4676 30.13C20.6085 29.5414 21.2469 26.2829 17.7315 26.2829C14.216 26.2829 14.8544 29.5414 15.0037 30.13C14.8627 30.0637 14.6638 30.0388 14.4979 30.3207C14.2409 30.7519 14.7964 31.9292 15.2607 31.838C15.5509 33.1563 15.9489 33.2475 15.9489 33.2475C16.0484 34.1098 15.8743 34.6902 15.8743 34.6902L15.6007 34.5243C15.6007 34.5243 15.3519 35.0384 14.9042 35.4032C14.4565 35.768 13.4118 36.1411 12.1018 36.9951C11.7204 37.2438 11.4302 37.4926 11.2146 37.7745C11.2063 37.7911 12.7651 40.6681 17.7398 40.6598Z",
    fill: "url(#paint4_linear_306_2035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5562 27.2779L30.2678 27.3028C29.8864 27.3028 29.5796 26.996 29.5796 26.6146V26.4985C29.5796 26.1172 29.8864 25.8104 30.2678 25.8104L50.5562 25.7855C50.9376 25.7855 51.2444 26.0923 51.2444 26.4737V26.5898C51.2444 26.9711 50.9293 27.2779 50.5562 27.2779Z",
    fill: "url(#paint5_linear_306_2035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0942 31.1416L30.2678 31.1581C29.8864 31.1581 29.5796 30.8514 29.5796 30.47V30.3539C29.5796 29.9725 29.8864 29.6657 30.2678 29.6657L43.0942 29.6491C43.4756 29.6491 43.7823 29.9559 43.7823 30.3373V30.4534C43.7823 30.8348 43.4756 31.1416 43.0942 31.1416Z",
    fill: "url(#paint6_linear_306_2035)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M57.5539 35.7349L30.2761 35.768C29.8947 35.768 29.5879 35.4612 29.5879 35.0799V34.9638C29.5879 34.5824 29.8947 34.2756 30.2761 34.2756L57.5539 34.2424C57.9353 34.2424 58.2421 34.5492 58.2421 34.9306V35.0467C58.2338 35.4281 57.927 35.7349 57.5539 35.7349Z",
    fill: "url(#paint7_linear_306_2035)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M56.9654 48.6442L11.4635 48.6939C11.0738 48.6939 10.7505 48.3789 10.7505 47.9809V47.9146C10.7505 47.5249 11.0656 47.2015 11.4635 47.2015L56.9654 47.1518C57.355 47.1518 57.6784 47.4668 57.6784 47.8648V47.9311C57.6784 48.3291 57.355 48.6442 56.9654 48.6442Z",
    fill: "url(#paint8_linear_306_2035)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M57.5539 40.2452L30.2761 40.2784C29.8947 40.2784 29.5879 39.9716 29.5879 39.5902V39.4742C29.5879 39.0928 29.8947 38.786 30.2761 38.786L57.5539 38.7528C57.9353 38.7528 58.2421 39.0596 58.2421 39.441V39.5571C58.2421 39.9385 57.9353 40.2452 57.5539 40.2452Z",
    fill: "url(#paint9_linear_306_2035)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_2035",
    x1: -8.65343,
    y1: 34.748,
    x2: 76.9993,
    y2: 62.5782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1713,
    stopColor: "#5EABFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4084,
    stopColor: "#509AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6698,
    stopColor: "#4890FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_306_2035",
    x1: -4.58984,
    y1: -21.375,
    x2: 56.3866,
    y2: 7.98971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_306_2035",
    x1: 14.6543,
    y1: 2.57952,
    x2: 53.5901,
    y2: 2.57952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_306_2035",
    x1: 14.7701,
    y1: 29.2075,
    x2: 24.5507,
    y2: 41.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_306_2035",
    x1: 13.7093,
    y1: 30.0293,
    x2: 23.4899,
    y2: 42.6553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0994384,
    stopColor: "#A1EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2994,
    stopColor: "#88E7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#77E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    stopColor: "#6CDDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_306_2035",
    x1: 29.5807,
    y1: 26.5509,
    x2: 51.24,
    y2: 26.5639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_306_2035",
    x1: 29.5847,
    y1: 30.4036,
    x2: 43.7815,
    y2: 30.4036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_306_2035",
    x1: 29.5894,
    y1: 35.0098,
    x2: 58.2375,
    y2: 35.0098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_306_2035",
    x1: 10.7501,
    y1: 47.9272,
    x2: 57.6761,
    y2: 47.9272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_306_2035",
    x1: 29.594,
    y1: 39.5191,
    x2: 58.2421,
    y2: 39.5191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_2035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.0754,
    height: 95,
    fill: "white",
    transform: "translate(0.635254)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameDetailsInfo);
export default __webpack_public_path__ + "static/media/Frame-DetailsInfo.d4f1f12622de8cc72568be9687004747.svg";
export { ForwardRef as ReactComponent };